import React from 'react';
import Logo from 'ui-component/icons/logo2';
import { useStyles } from './index.style';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const { styles } = useStyles();
  return (
    <div className={styles.logo}>
      <Logo width={150} height={39} />
    </div>
  );
};

export default LogoSection;
